/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './wine-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const wineSlider = () => {
    let args = {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1000,
        loop: true,
        loopAdditionalSlides: 100,
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                allowTouchMove: false,
            },
            768: {
                slidesPerView: 1,
                allowTouchMove: true,
                loop: true
            }
        }
    };
    let wineSwipers = document.querySelectorAll('.wineSwiper');
    wineSwipers.forEach((el) => {
        let wineSwiper = new Swiper(el, args);
        
        // wineSwiper.slides.forEach((slide, index) => {
        //     slide.addEventListener('click', () => {
        //         const slideIndex = slide.getAttribute('data-swiper-slide-index');
        //         wineSwiper.slideTo(slideIndex);
        //         console.log(slideIndex);
        //         wineSwiper.updateSlidesClasses()
        //     });
        // });
    })
}

export default wineSlider;

//--------------------------------------------------------------------//